function ButtonComponent(text, onClick) {
  return `
    <button class='rounded-md bg-indigo-600 px-3.5 py-1.5 text-base font-semibold leading-7 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
          onclick='${onClick}'
       >${text}</button>
  `;
}

export default ButtonComponent;
